import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../.././shared/shared.service';
import { BaseComponent } from '../.././shared/base.component';

import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { FPMessage, Severities } from '../.././shared/shared.model';
import { CapitalizeFirstPipe } from '../.././shared/pipes/custom-pipes.pipe';
import { DatePipe } from '@angular/common';
import { Vendor } from '../../work-order/work-order-models';
import { WoService } from '../../work-order/work-order.service';

@Component({
    // moduleId: module.id,
    selector: 'assign-vendor',
    templateUrl: 'assign-vendor.component.html',
    providers: [DatePipe]
})
export class AssignVendorComponent extends BaseComponent implements OnInit {
    @Input() woJobId: number;
    @Input() vendorId: number;
    @Input() remarks: string;
    @Input() projectId: number;
    @Output() openCloseAssignVendor = new EventEmitter;
    @Input() CustomerId?: number;
    @Input() IsQuote?: number;
    @Input() WOId: number;
    header: string;
    frmAssignVendor: FormGroup;
    IsExistinlookup: boolean = false;
    vendor: Vendor[] = [];

    message: FPMessage;
    IsPreferVendor: boolean = false;

    constructor(protected translateService: TranslateService, protected woService: WoService, protected sharedService: SharedService
        , private formBuilder: FormBuilder, private datePipe: DatePipe) {
        super(sharedService, translateService)

    }
    ngOnInit() {debugger
        this.IsPreferVendor = this.sharedService.isEnablePreferredVendor;
        this.header = this.translate.instant('ASSIGNTOVENDOR');
        this.frmAssignVendor = this.formBuilder.group({
            VendorId: ['0'],
            Remarks: [''],
        });

        this.woService.getCustomerVendorList(super.globalInfo().CompanyId, super.globalInfo().LoginId, super.globalInfo().MaxRoleGroup, super.globalInfo().ProjectEnabled == 0 ? null : this.projectId == 0 ? null : this.projectId, this.CustomerId, super.globalInfo().MaxRoleGroup == 3 ? super.globalInfo().VendorId : null).subscribe(res => {
            this.vendor = res;
            var Id = this.vendor.filter(x => x.VendorId == this.vendorId);
            if (Id.length > 0)
                this.frmAssignVendor.controls["VendorId"].setValue(this.vendorId == null ? 0 : this.vendorId);
            else
                this.frmAssignVendor.controls["VendorId"].setValue(0);

            this.frmAssignVendor.controls["Remarks"].setValue(this.remarks == null ? '' : this.remarks);
            if (this.IsPreferVendor && this.vendorId == null) {
                if (super.globalInfo().MaxRoleGroup == 3) {
                    this.frmAssignVendor.controls['VendorId'].setValue(super.globalInfo().VendorId);
                    this.frmAssignVendor.controls["VendorId"].disable();
                }
                else if (super.globalInfo().MaxRoleGroup == 5 || super.globalInfo().MaxRoleGroup == 6) {
                    if (this.vendor.length == 1) {
                        this.frmAssignVendor.controls['VendorId'].setValue(this.vendor[0].VendorId);
                    }
                    else if (this.vendor.find(x => x.IsPrimaryVendorId == 1))
                        this.frmAssignVendor.controls['VendorId'].setValue(this.vendor.find(x => x.IsPrimaryVendorId == 1).VendorId);
                    else
                        this.frmAssignVendor.controls['VendorId'].setValue(this.vendor[0].VendorId);

                }
                else {
                    if (this.vendor.length == 1) {
                        this.frmAssignVendor.controls['VendorId'].setValue(this.vendor[0].VendorId);
                    }
                    else {
                        this.frmAssignVendor.controls['VendorId'].setValue(0);
                    }
                }
            }
        });

    } //onInit ends

    saveAssignVendor() {
        this.woService.updateJobAssignVendor(super.globalInfo().CompanyId, this.woJobId, this.frmAssignVendor.controls['VendorId'].value == 0 ? null : this.frmAssignVendor.controls['VendorId'].value, this.frmAssignVendor.controls['Remarks'].value, super.globalInfo().LoginId, this.IsQuote, this.WOId).subscribe(s => {
            this.message = s.Message;

            if (s.Message.Severity == Severities.success) {
                if (this.message.MessageCode == "1001" || this.message.MessageCode == "1002") {
                    this.sharedService.notification.emit({
                        severity: Severities[this.message.Severity],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                        detail: this.translate.instant('VENDOR') + " " + this.translate.instant(this.message.MessageCode)
                    });
                }
            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant(this.message.MessageCode)
                });
            }

            this.openCloseAssignVendor.emit(true);
        });
    }


    closeAssignVendor() {

        this.openCloseAssignVendor.emit(null);
    }
}